// extracted by mini-css-extract-plugin
export default {"drawer":"CreateAccessProfile_drawer__VDPWK"};